import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withAsyncPaginate } from 'react-select-async-paginate';
import { CheckboxSelect } from '@atlaskit/select';
import _ from 'lodash';

import { GET_PROJECTS } from './graphql';
import client from '../../services/graphql';

// DO NOT put this inside of the component, it MUST STAY OUTSIDE
const CustomAsyncPaginate = withAsyncPaginate(CheckboxSelect);

const defaultStyles = {
  fontSize: '14px',
  fontFamily: 'Roboto',
  color: '#192C47',
};

const inputStyles = {
  backgroundColor: '#FFFFFF',
  borderColor: '#EFEFEF',
};

// docs styling https://react-select.com/styles
// check more in this file: react-select/dist/declarations/src/styles.d.ts
const customStyles = {
  option: (styles) => ({
    ...styles,
    ...defaultStyles,
  }),
  control: (styles) => ({
    ...styles,
    ...inputStyles,
    borderWidth: '1px',
    borderColor: 'rgba(34,36,38,.15)',
    '&:hover': {
      borderColor: 'rgba(34,36,38,.35) !important', // No border color change on hover
      backgroundColor: `${inputStyles.backgroundColor} !important`, // No background color change on hover
    },
  }),
  placeholder: (styles) => ({
    ...styles,
    ...defaultStyles,
  }),
  menuList: (styles) => ({
    ...styles,
    ...defaultStyles,
  }),
  valueContainer: (styles) => ({
    ...styles,
    maxHeight: '38px',
    overflowY: 'auto',
  }),
};

const ProjectsDropdown = (props) => {
  const {
    companyId,
    setSelectedProjects,
    selectedProjects, // set the input with projects selected
    isDisabled,
  } = props;

  const [value, setValue] = useState(selectedProjects || null);
  const LIMIT = 10;

  const onChange = (newValue) => {
    setValue(newValue);
    setSelectedProjects(_.map(newValue, 'id'));
  };

  const loadOptions = async (search, loadedOptions) => {
    if (!companyId) {
      return { options: [], hasMore: false };
    }

    const { data } = await client.getClient().query({
      query: GET_PROJECTS,
      variables: {
        limit: LIMIT,
        companyId,
        offset: loadedOptions.length,
        order: 'name asc',
        name: search,
      },
    });
    const { projects = [] } = data;

    // graphql returns all objects instead of sliced, so we slice here
    const slicedOptions = projects.slice(
      loadedOptions.length,
      loadedOptions.length + LIMIT,
    );
    const hasMore = slicedOptions.length >= LIMIT;

    return {
      options: slicedOptions,
      hasMore,
    };
  };

  return (
    <CustomAsyncPaginate
      SelectComponent={CheckboxSelect}
      value={value}
      loadOptions={loadOptions}
      onChange={onChange}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.name}
      isSearchable
      isDisabled={isDisabled}
      placeholder="Select a project"
      styles={customStyles}
    />
  );
};

ProjectsDropdown.defaultProps = {
  isDisabled: false,
  selectedProjects: null,
};

ProjectsDropdown.propTypes = {
  companyId: PropTypes.string.isRequired,
  setSelectedProjects: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  selectedProjects: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
};

export default ProjectsDropdown;
